mutation OpenContentPoll($id: ID!) {
  openContentPoll(id: $id) {
    id
    status
    openedAt
  }
}
